import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  TextField,
  Grid2,
  Typography,
  Grid,
  InputAdornment,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ServicesCard from "./ServicesCard";
import { useNavigate } from "react-router-dom";
import LoadingAnimation from "../Animations/LoadingAnimation";
import { fonts, mainButtonStyles, semiBoldFonts } from "../../Styles/Styles";

const ServicesPage = () => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState(""); // To track user input
  const [debouncedQuery, setDebouncedQuery] = useState(""); // For debounced value

  const navigate = useNavigate();

  // Debounce the search query
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedQuery(searchQuery);
    }, 500); // Adjust debounce time as needed

    return () => {
      clearTimeout(handler);
    };
  }, [searchQuery]);

  // Fetch services from the backend
  const fetchServices = async (query = "") => {
    setLoading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_SERVER_BASE_URL}/services/parentServices?search=${query}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );
      const data = await response.json();
      setServices(data); // Assuming data is an array of services
    } catch (error) {
      console.error("Error fetching services:", error);
    } finally {
      setLoading(false);
    }
  };

  // Fetch services whenever the debounced query changes
  useEffect(() => {
    fetchServices(debouncedQuery);
  }, [debouncedQuery]);

  const MyServices = () => {
    navigate("/my-services");
  };

  return (
    <Box>
      <Box
        sx={{
          position: "relative",
          width: "100%",
          height: "50vh",
          backgroundImage: `url(/Images/BG-Lines-Listed-1.png)`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          color: "white",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
          }}
        />
        <Box sx={{ position: "relative", zIndex: 1, textAlign: "center" }}>
          <Typography variant="h4" sx={{ ...semiBoldFonts, letterSpacing: 2 }}>
            SERVICES
          </Typography>
          <Typography variant="h6" color="white" mt={1} sx={{ ...fonts }}>
            Browse through our list of Services to find the service provider for
            your needs.
          </Typography>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Button onClick={MyServices} sx={{ mt: 2, ...mainButtonStyles }}>
              Become a Service Provider
            </Button>
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          p: 3,
          width: "95%",
          margin: "0 auto",
        }}
      >
        {/* Search Bar */}
        <Grid container sx={{ mt: 2, mb: 4 }} justifyContent="center">
          <Grid item xs={12} sm={10} md={6}>
            <TextField
              fullWidth
              variant="outlined"
              placeholder="Search Services"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon sx={{ color: "var(--primary-color)" }} />
                  </InputAdornment>
                ),
              }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  fontFamily: "ClashGrotesk-Regular",
                  letterSpacing: 1,
                  borderRadius: "50px",

                  // Normal state
                  "& fieldset": {
                    borderColor: "rgba(0, 0, 0, 0.2)",
                  },

                  // Hover state
                  "&:hover fieldset": {
                    borderColor: "var(--primary-color)",
                  },

                  // Focused state
                  "&.Mui-focused fieldset": {
                    borderColor: "var(--primary-color)",
                    borderWidth: "2px",
                  },
                },
                "& .MuiInputLabel-root": {
                  fontFamily: "ClashGrotesk-Regular",
                  letterSpacing: 1,
                },
                "& .MuiOutlinedInput-input": {
                  fontFamily: "ClashGrotesk-Regular",
                  letterSpacing: 1,
                },
              }}
            />
          </Grid>
        </Grid>
        {loading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "300px",
            }}
          >
            <LoadingAnimation />
          </Box>
        ) : (
          <Grid2 container spacing={2} sx={{ mb: 4 }}>
            {services.map((service, index) => (
              <Grid2 item size={{ xs: 12, sm: 4, md: 2.4 }} key={index}>
                <ServicesCard service={service} />
              </Grid2>
            ))}
          </Grid2>
        )}
      </Box>
    </Box>
  );
};

export default ServicesPage;
